export class UserAccountSessionPolicy {
  allowsBetterAuthCookieSession(accountStatus: string): boolean {
    return accountStatus === "active";
  }

  isEligibleForInviteTokenFlow(accountStatus: string): boolean {
    return accountStatus === "invited";
  }
}
